import { VerticalNavLink } from './helpLinks-helpers';

export interface TrialModalProps {
    onClose: () => void;
}

// help links for the modal
export const links: VerticalNavLink[] = [
    {
        label: 'Developer Docs',
        href: 'https://docs.in.burstiq.com/dev-docs',
        external: true,
    },
    {
        label: 'API Docs',
        href: 'https://docs.in.burstiq.com/api-docs/',
        external: true,
    },
    {
        label: 'Training Materials',
        href: 'https://docs.in.burstiq.com/',
        external: true,
    },
    { label: 'Ask Blast', href: '/ask-blast', external: false },
];

export const trialModalStyles = {
    paper: {
        width: 399,
        minHeight: 503,
        borderRadius: '10px',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    },
    dialogContent: {
        p: 0,
        flex: 1,
        overflow: 'visible',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        marginTop: '28px',
        alignItems: 'center',
    },
    innerContent: {
        px: '32px',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
    },
    image: {
        width: '223px',
        height: 'auto',
    },
    links: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        heading: {
            mt: '20px',
            color: '#285C6C',
            textAlign: 'center',
            fontFamily: 'Raleway',
            fontWeight: 600,
            fontSize: '28px',
        },
        text: {
            my: '8px',
            color: '#293541',
            textAlign: 'center',
            fontFamily: 'Red Hat Text',
            fontWeight: 400,
            fontSize: '14px',
        },
    },
    actions: {
        p: 2,
        pt: 1,
        flexShrink: 0,
        backgroundColor: '#fff',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        dismiss: {
            // margin: '4px 0 4px 12px',
            mt: '16px',
            mb: '24px',
            ml: '8px',
            mr: '20px',
            padding: '4px 10px',
            whiteSpace: 'nowrap',
            width: '150px',
            height: '30px',
            fontSize: '14px',
            fontWeight: '700',
            lineHeight: '22px',
            letterSpacing: '.5px',
        },
    },
};
